@if (appliedFilters?.length) {
  <div>
    <div
      class="d-flex align-items-center gap-2 flex-wrap mt-2"
      [ngClass]="(appliedFilters | misc: 'excludeDateFilters') ? 'mb-3' : ''"
    >
      @for (filter of appliedFilters; track filter) {
        <div>
          @if (!filter?.datetimeObj) {
            <div class="d-flex align-items-center gap-2">
              <button class="btn btn-outline-primary py-1">
                {{ filter?.key | uppercase }} {{ filter?.value }}
              </button>
              <span (click)="removeFilter(filter?.key)">
                <i class="fa-solid fa-xmark"></i>
              </span>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
@if (filterSortData?.length) {
  @if (selectedCardDetail && filterSortData?.length === 1) {
    <ng-template
      *ngTemplateOutlet="
        filterDetailTemplate;
        context: { value: selectedCardDetail }
      "
    ></ng-template>
  } @else {
    @for (selectedFilter of filterSortData; track selectedFilter) {
      <ng-template
        *ngTemplateOutlet="
          filterDetailTemplate;
          context: { value: selectedFilter }
        "
      ></ng-template>
    }
    <!-- Show Header Toggle -->
    @if (isSuperUser) {
      <div class="form-check form-switch mb-2">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="showHeader"
          data-toggle="toggle"
          (change)="showHideHeader($event)"
          id="header"
        />
        <label class="form-check-label" for="header">Show Header</label>
      </div>
    }
  }
}
<div
  class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xxl-3 row-cols-xxxl-6 mb-3 pe-2"
>
  <!-- Card Sections split into multiple sections based on screen size -->
  <!-- row-cols-md-2 row-cols-xxl-3 row-cols-xxxl-6 -->
  @for (data of cardData; track data; let i = $index) {
    <div class="h-100">
      <div
        class="d-flex justify-content-between gt-card"
        [ngClass]="otherParams?.removeCardPointer ? '' : 'cursor-pointer'"
        [ngStyle]="getCardItemStyle(data, i)"
        (click)="onRowClick(data, i)"
      >
        <div class="flex-grow-1">
          @for (
            indCard of mobileCardDetails?.individualDetails;
            track indCard
          ) {
            <div class="d-block">
              <!-- Style whole row either based on condition or common to all -->
              <span
                [ngStyle]="
                  indCard?.conditionalRowStyle
                    ? indCard?.conditionalRowStyle(data)
                    : indCard?.cardRowStyle
                "
              >
                @if (
                  showHeader &&
                  (indCard.nestedValue
                    ? indCard.nestedValue(data)
                    : data[indCard.name]) != null
                ) {
                  <span
                    [ngStyle]="
                      indCard?.conditionalHeaderRowStyle
                        ? indCard?.conditionalHeaderRowStyle(data)
                        : indCard?.cardHeaderRowStyle
                    "
                  >
                    <!-- Header content which will be passed from the backend STARTS-->
                    <dt
                      [ngStyle]="
                        indCard?.conditionalHeaderRowDataStyle
                          ? indCard?.conditionalHeaderRowDataStyle(data)
                          : indCard?.rowHeaderDataStyle
                      "
                    >
                      {{
                        indCard.nestedHeaderValue
                          ? indCard.nestedHeaderValue(data)
                          : indCard.header
                      }}
                    </dt>
                    <!-- Header content which will be passed from the backend ENDS-->
                  </span>
                }
                <!-- A row is typically divided into 3 parts: prefix, main content, and suffix. Style each of them based on conditions or common styles -->
                <span
                  [ngStyle]="
                    indCard?.conditionalPrefixStyle
                      ? indCard?.conditionalPrefixStyle(data)
                      : indCard?.prefixStyle
                  "
                >
                  <!-- Prefix (either hardcoded from UI or passed from backend via key-value pair) STARTS -->
                  {{
                    indCard?.prefixNestedValue
                      ? indCard?.prefixNestedValue(data)
                      : indCard?.prefix
                        ? indCard?.prefix
                        : ""
                  }}
                </span>
                <!-- Prefix (either hardcoded from UI or passed from backend via key-value pair) ENDS -->
                <!-- Main content which will be passed from the backend STARTS -->
                <span
                  [ngStyle]="
                    indCard?.conditionalRowDataStyle
                      ? indCard?.conditionalRowDataStyle(data)
                      : indCard?.rowDataStyle
                  "
                >
                  @if (
                    indCard?.imageObj === true &&
                    (indCard.nestedValue
                      ? indCard.nestedValue(data)
                      : data[indCard.name])
                  ) {
                    <img
                      [ngStyle]="
                        indCard?.conditionalImageStyle
                          ? indCard?.conditionalImageStyle(data)
                          : indCard?.imageStyle
                      "
                      src="{{
                        indCard.mediaSrc
                          ? indCard.mediaSrc
                          : indCard.nestedValue
                            ? indCard.nestedValue(data)
                            : data[indCard.name]
                      }}"
                    />
                  }
                  @if (indCard?.datetimeObj == true) {
                    {{
                      indCard.nestedValue
                        ? (indCard.nestedValue(data)
                          | customDate
                            : (indCard.dateTimeFormat
                                ? indCard.dateTimeFormat
                                : "d MMM y HH:mm"))
                        : (data[indCard.name]
                          | customDate
                            : (indCard.dateTimeFormat
                                ? indCard.dateTimeFormat
                                : "d MMM y HH:mm"))
                    }}
                  }
                  @if (!indCard?.datetimeObj && !indCard?.imageObj) {
                    {{
                      indCard.nestedValue
                        ? indCard.nestedValue(data)
                        : data[indCard.name]
                    }}
                  }
                </span>
                <!-- Main content which will be passed from the backend ENDS -->
                <!-- Suffix (either hardcoded from UI or passed from backend via key-value pair) STARTS -->
                <span
                  [ngStyle]="
                    indCard?.conditionalSuffixStyle
                      ? indCard?.conditionalSuffixStyle(data)
                      : indCard?.suffixStyle
                  "
                >
                  {{
                    indCard?.suffixNestedValue
                      ? indCard?.suffixNestedValue(data)
                      : indCard?.suffix
                        ? indCard?.suffix
                        : ""
                  }}
                </span>
                <!-- Suffix (either hardcoded from UI or passed from backend via key-value pair) ENDS -->
              </span>
              <!-- Rows where objects are normal objects ENDS -->
            </div>
          }
        </div>
        @if (mobileActionIcons) {
          <div class="d-flex flex-column ms-auto ps-2 gap-2">
            @for (actionIcon of mobileActionIcons; track actionIcon) {
              @if (actionIcon.condition(data).type) {
                <div>
                  <span
                    class="text-end"
                    (click)="
                      onActionClick(data, actionIcon.condition(data).type);
                      $event.stopImmediatePropagation()
                    "
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="{{ actionIcon.condition(data).title }}"
                  >
                    <i [class]="actionIcon.condition(data).icon"></i>
                  </span>
                </div>
              }
            }
          </div>
        }
      </div>
    </div>
  }
</div>

@if (cardData?.length == 0) {
  <div>
    <div class="alert" role="alert">No Records Found</div>
  </div>
}
@if (otherParams?.paginationData) {
  <div>
    <gtapp-pagination-control
      [pageSize]="rows"
      [pageNum]="pageNum"
      [previous]="previousRows"
      [totalRows]="totalRows"
      (onChangePagination)="onChangePagination($event)"
    >
    </gtapp-pagination-control>
  </div>
}

<ng-template #filterDetailTemplate let-selectedFilter="value">
  <div class="my-2">
    @if (selectedFilter?.dateRangeKey) {
      <div class="col form-floating" (click)="openRangePicker(selectedFilter)">
        <input
          class="form-control input-font-sm"
          placeholder="Showing Data Between"
          readonly
          [(ngModel)]="selectedFilter.dateRangeValue"
        />
        <label>Showing Data Between </label>
      </div>
    }
    @if (selectedFilter?.opendropDownBox) {
      <div class="col form-floating">
        <select
          class="form-select"
          placeholder="Status"
          (selectedChange)="selectStatus($event, selectedFilter)"
        >
          @for (status of selectedFilter?.dropDownList(); track status) {
            <div>
              {{ status?.name }}
            </div>
          }
        </select>
      </div>
    }
    @if (selectedFilter?.searchKey) {
      @if (selectedFilter?.autoComplete) {
        <gtapp-auto-complete
          [data]="autoCompleteSearchResultList"
          placeHolder="Filter by {{
            selectedFilter | misc: 'getFilterHeader' | titlecase
          }}"
          [searchKeyword]="selectedFilter?.autoComplete"
          [initialValue]="selectedFilter.searchValue"
          [itemTemplate]="autoCompleteTemplate"
          [enableSearchCloseOption]="true"
          (inputChanged)="onAutoCompleteInputSearch($event, selectedFilter)"
          (selected)="onAutoCompleteItemSelect($event, selectedFilter)"
          (submitted)="onAutoCompleteSearch($event, selectedFilter)"
        >
        </gtapp-auto-complete>
        <ng-template #autoCompleteTemplate let-item>
          <div>
            {{ item?.full_name }}
          </div>
        </ng-template>
      } @else {
        <div class="input-group">
          <div class="col form-floating">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="selectedFilter.searchValue"
              placeholder="Search"
              (keyup.enter)="searchField(selectedFilter)"
            />
            <label
              >Search
              {{ selectedFilter | misc: "getFilterHeader" | titlecase }}</label
            >
          </div>
          @if (
            selectedFilter?.searchKey &&
            cardData?.length &&
            selectedFilter.searchValue
          ) {
            <span
              class="input-group-text"
              (click)="searchField(selectedFilter)"
            >
              <i class="fa-solid fa-magnifying-glass"></i>
            </span>
          }
          @if (
            !selectedFilter?.openSearchBox &&
            selectedFilter?.sortKey &&
            cardData?.length
          ) {
            <span class="input-group-text" (click)="sortField(selectedFilter)">
              <i class="fa fa-sort"></i>
            </span>
          }
        </div>
      }
    }
  </div>
</ng-template>
